export default "__VITE_ASSET__mib7if1n__"